/**
 * Single vocabulary for banner, ops strip, and global status (aligned with StatusPill per-row labels).
 * Tier derives from the same rules as GrafanaDashboard status banner.
 */
export type StatusTier = 'outage' | 'degraded' | 'normal';

export function getStatusTier(
  currentStatus: 'normal' | 'degraded' | 'major_outage' | undefined,
  connectivity: number
): StatusTier {
  const outage = currentStatus === 'major_outage' || connectivity < 50;
  if (outage) return 'outage';
  const degraded = currentStatus === 'degraded' || (connectivity >= 50 && connectivity < 80);
  if (degraded) return 'degraded';
  return 'normal';
}

export function bannerTitle(tier: StatusTier, isFa: boolean): string {
  if (isFa) {
    if (tier === 'outage') return 'قطع گسترده';
    if (tier === 'degraded') return 'اختلال جزئی';
    return 'همه سیستم‌ها در وضعیت عادی';
  }
  if (tier === 'outage') return 'Major outage';
  if (tier === 'degraded') return 'Partial disruption';
  return 'All systems normal';
}

/** Ops strip — uppercase, short */
export function opsStripLabel(tier: StatusTier, isFa: boolean): string {
  if (isFa) {
    if (tier === 'outage') return 'قطع گسترده فعال';
    if (tier === 'degraded') return 'اختلال شناسایی شد';
    return 'وضعیت عادی';
  }
  if (tier === 'outage') return 'MAJOR OUTAGE ACTIVE';
  if (tier === 'degraded') return 'DISRUPTION DETECTED';
  return 'NOMINAL';
}

/** Plain-English interpretation under banner title — only for outage & degraded */
export function bannerSubline(tier: StatusTier, isFa: boolean): string | null {
  if (tier === 'normal') return null;
  if (isFa) {
    if (tier === 'outage') {
      return 'کاهش گستردهٔ دسترسی بین‌المللی در چندین شبکهٔ ایرانی شناسایی شد.';
    }
    return 'کاهش اتصال در برخی شبکه‌ها — در حال پایش برای تشدید.';
  }
  if (tier === 'outage') {
    return 'Widespread international reachability loss detected across Iranian ISPs.';
  }
  return 'Reduced connectivity on some networks — monitoring for escalation.';
}
